import { GridApi } from "ag-grid-enterprise";

export const customSearchForActivityReport = (text: string, api: GridApi) => {
  if (api) {
    api.forEachNode((rowNode) => {
      if (!rowNode.data.detailNode) return;
      const { childrenMapped } = rowNode.data.detailNode;
      if (childrenMapped) {
        const { gridRefLinkedMaterial, gridRefLinkedSubmittal } =
          childrenMapped;
        if (gridRefLinkedMaterial && gridRefLinkedMaterial.current) {
          const mApi = gridRefLinkedMaterial.current.api as GridApi;
          mApi?.setGridOption("quickFilterText", text);
          mApi.forEachNode((mRowNode) => {
            if (
              mRowNode.data.detailNode &&
              mRowNode.data.detailNode.detailGridInfo
            ) {
              const gridInfo = mRowNode.data.detailNode.detailGridInfo;
              gridInfo.api?.setGridOption("quickFilterText", text);
            }
          });
        }
        if (gridRefLinkedSubmittal && gridRefLinkedSubmittal.current) {
          const mApi = gridRefLinkedSubmittal.current.api as GridApi;

          mApi?.setGridOption("quickFilterText", text);
        }
      }
    });
    api.setGridOption("quickFilterText", text);
  }
};
